(() => {
  const VIEW_KEY = 'lb-collection-view';

  const getStoredView = () => {
    try {
      return localStorage.getItem(VIEW_KEY) || 'grid';
    } catch (e) {
      return 'grid';
    }
  };

  const setStoredView = (view) => {
    try {
      localStorage.setItem(VIEW_KEY, view);
    } catch (e) {
      /* storage unavailable */
    }
  };

  const setView = (view, root = document) => {
    const grid = root.querySelector('[data-collection-grid]');
    const buttons = root.querySelectorAll('[data-collection-view]');
    if (!grid) return;
    grid.dataset.view = view;
    buttons.forEach((b) => {
      const active = b.dataset.collectionView === view;
      b.classList.toggle('text-primary', active);
      b.classList.toggle('bg-secondary/50', active);
      b.classList.toggle('text-foreground/50', !active);
      b.setAttribute('aria-pressed', String(active));
    });
  };

  const initViewToggle = (root) => {
    const stored = getStoredView();
    setView(stored, root);

    root.querySelectorAll('[data-collection-view]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const view = btn.dataset.collectionView;
        setView(view, root);
        setStoredView(view);
      });
    });
  };

  const initSort = (root) => {
    const sort = root.querySelector('[data-collection-sort]');
    if (!sort) return;
    const toggle = sort.querySelector('[data-collection-sort-toggle]');
    const menu = sort.querySelector('[data-collection-sort-menu]');
    const chevron = sort.querySelector('[data-collection-sort-chevron]');
    if (!toggle || !menu) return;

    const open = () => {
      menu.classList.remove('hidden');
      chevron?.classList.add('rotate-180');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const close = () => {
      menu.classList.add('hidden');
      chevron?.classList.remove('rotate-180');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      if (menu.classList.contains('hidden')) open();
      else close();
    });

    document.addEventListener('click', (e) => {
      if (!sort.contains(e.target)) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  };

  const initFilters = (root) => {
    const toggle = root.querySelector('[data-collection-filters-toggle]');
    const desktop = root.querySelector('[data-collection-filters-sidebar]');
    const mobile = root.querySelector('[data-collection-filters-mobile]');
    if (!toggle) return;

    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;

    // Open/closed is expressed as a state class rather than `display`, so the
    // sidebar can transition. `inert` keeps the collapsed panel out of the tab
    // order while it is still technically in the layout.
    const openDesktop = () => {
      desktop?.classList.remove('is-closed');
      desktop?.removeAttribute('inert');
      toggle.setAttribute('aria-expanded', 'true');
    };
    const closeDesktop = () => {
      desktop?.classList.add('is-closed');
      desktop?.setAttribute('inert', '');
      toggle.setAttribute('aria-expanded', 'false');
    };
    const openMobile = () => {
      mobile?.classList.add('is-open');
      mobile?.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
      toggle.setAttribute('aria-expanded', 'true');
    };
    const closeMobile = () => {
      mobile?.classList.remove('is-open');
      mobile?.setAttribute('inert', '');
      document.body.style.overflow = '';
      toggle.setAttribute('aria-expanded', 'false');
    };

    mobile?.setAttribute('inert', '');

    toggle.addEventListener('click', () => {
      if (isDesktop()) {
        const isOpen = !desktop?.classList.contains('is-closed');
        if (isOpen) closeDesktop();
        else openDesktop();
      } else {
        openMobile();
      }
    });

    root.querySelectorAll('[data-collection-filters-close]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (isDesktop()) closeDesktop();
        else closeMobile();
      });
    });

    const backdrop = root.querySelector('[data-collection-filters-backdrop]');
    backdrop?.addEventListener('click', closeMobile);

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (mobile?.classList.contains('is-open')) closeMobile();
      else if (isDesktop()) closeDesktop();
    });
  };

  const initFilterGroups = (root) => {
    root.querySelectorAll('[data-filter-group]').forEach((group) => {
      const btn = group.querySelector('[data-filter-toggle]');
      const content = group.querySelector('[data-filter-content]');
      const chev = group.querySelector('[data-filter-chevron]');
      if (!btn || !content) return;
      btn.addEventListener('click', () => {
        const open = content.classList.contains('max-h-0');
        content.classList.toggle('max-h-0', !open);
        content.classList.toggle('opacity-0', !open);
        content.classList.toggle('max-h-96', open);
        content.classList.toggle('opacity-100', open);
        chev?.classList.toggle('rotate-180', open);
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  };

  const initFilterCheckboxes = (root) => {
    root.querySelectorAll('[data-filter-checkbox]').forEach((cb) => {
      cb.addEventListener('change', () => {
        const url = cb.dataset.filterUrl;
        if (url) window.location.href = url;
      });
    });
  };

  const init = () => {
    document.querySelectorAll('[data-collection]').forEach((root) => {
      initViewToggle(root);
      initSort(root);
      initFilters(root);
      initFilterGroups(root);
      initFilterCheckboxes(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
